import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_show_ticket_body",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "modalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-900px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header pb-0 border-0 justify-content-end" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = ["element-loading-text"]
const _hoisted_8 = {
  key: 0,
  class: "d-flex flex-column flex-lg-row"
}
const _hoisted_9 = { class: "flex-column flex-lg-row-auto w-100 w-lg-200px w-xl-300px mb-10 mb-lg-0" }
const _hoisted_10 = { class: "card mb-5 mb-xl-8" }
const _hoisted_11 = { class: "card-body bg-gray-100 rounded pt-15" }
const _hoisted_12 = { class: "d-flex flex-center flex-column mb-5" }
const _hoisted_13 = { class: "fs-3 text-gray-800 text-hover-primary fw-bolder mb-1" }
const _hoisted_14 = {
  class: "fs-5 fw-bold text-muted mb-6 text-end",
  dir: "ltr"
}
const _hoisted_15 = { class: "d-flex flex-stack fs-4 py-3" }
const _hoisted_16 = {
  class: "fw-bolder rotate collapsible",
  "data-bs-toggle": "collapse",
  href: "#kt_customer_view_details",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "kt_customer_view_details"
}
const _hoisted_17 = { class: "ms-2 rotate-180" }
const _hoisted_18 = { class: "svg-icon svg-icon-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-3" }, null, -1)
const _hoisted_20 = {
  id: "kt_customer_view_details",
  class: "collapse show"
}
const _hoisted_21 = { class: "py-5 fs-6" }
const _hoisted_22 = { class: "badge badge-light-info d-inline" }
const _hoisted_23 = { class: "fw-bolder mt-5" }
const _hoisted_24 = { class: "text-gray-600" }
const _hoisted_25 = { class: "fw-bolder mt-5" }
const _hoisted_26 = { class: "text-gray-600" }
const _hoisted_27 = { class: "text-gray-600 text-hover-primary" }
const _hoisted_28 = { class: "fw-bolder mt-5" }
const _hoisted_29 = { class: "text-gray-600" }
const _hoisted_30 = { class: "text-gray-600 text-hover-primary" }
const _hoisted_31 = { class: "fw-bolder mt-5" }
const _hoisted_32 = { class: "text-gray-600" }
const _hoisted_33 = { class: "fw-bolder mt-5" }
const _hoisted_34 = { class: "text-gray-600" }
const _hoisted_35 = { class: "flex-lg-row-fluid ms-lg-7 ms-xl-10" }
const _hoisted_36 = { class: "card shadow-none" }
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = {
  ref: "el",
  class: "scroll-y me-n5 pe-5 h-500px",
  "data-kt-element": "messages",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: true, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer",
  "data-kt-scroll-wrappers": "#kt_content, #kt_chat_messenger_body",
  "data-kt-scroll-offset": "-2px"
}
const _hoisted_39 = {
  class: "card-footer pt-4",
  id: "kt_chat_messenger_footer"
}
const _hoisted_40 = ["placeholder"]
const _hoisted_41 = { class: "d-flex flex-stack" }
const _hoisted_42 = { class: "d-flex align-items-center me-2" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "indicator-label" }
const _hoisted_45 = { class: "indicator-progress" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "indicator-label" }
const _hoisted_49 = { class: "indicator-progress" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_Date = _resolveComponent("Date")!
  const _component_MessageIn = _resolveComponent("MessageIn")!
  const _component_MessageOut = _resolveComponent("MessageOut")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "modal-body scroll-y pt-0 pb-15",
          "element-loading-text": _ctx.translate('loading')
        }, [
          (_ctx.list && _ctx.list.creator)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_UserAvatar, {
                          avatar: _ctx.list.creator.picture,
                          size: "100px",
                          id: _ctx.list.creator.id
                        }, null, 8, ["avatar", "id"]),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.list.creator.first_name + " " + _ctx.list.creator.last_name), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.list.creator.mobile), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createTextVNode(_toDisplayString(_ctx.translate("details")) + " ", 1),
                          _createElementVNode("span", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, [
                              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr072.svg" })
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.translate("Normal user")), 1),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.translate("Ticket number")), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.list.ticket_number), 1),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.translate("Related section")), 1),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.list.department.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.translate("Priority ticket")), 1),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("span", _hoisted_30, [
                              _createElementVNode("span", {
                                class: _normalizeClass(`badge badge-light-${_ctx.statusColor(
                              _ctx.list.priority
                            )}`)
                              }, _toDisplayString(_ctx.translate(_ctx.list.priority)), 3)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.translate("the date of creation")), 1),
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_Date, {
                              date: _ctx.list.created_at
                            }, null, 8, ["date"])
                          ]),
                          _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.translate("last update")), 1),
                          _createElementVNode("div", _hoisted_34, [
                            (_ctx.list.last_change_status_date)
                              ? (_openBlock(), _createBlock(_component_Date, {
                                  key: 0,
                                  date: _ctx.list.last_change_status_date
                                }, null, 8, ["date"]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_MessageIn, {
                          name: 
                        _ctx.list.creator.first_name + ' ' + _ctx.list.creator.last_name
                      ,
                          image: _ctx.list.creator.picture,
                          time: _ctx.list.created_at.jalali,
                          text: _ctx.list.message,
                          user_type: "user"
                        }, null, 8, ["name", "image", "time", "text"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.replies, (item, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (item.user.id === _ctx.list.creator.id)
                              ? (_openBlock(), _createBlock(_component_MessageIn, {
                                  key: 0,
                                  name: `${item.user.full_name}`,
                                  image: item.user.avatar,
                                  time: item.created_at.jalali,
                                  text: item.message,
                                  user_type: item.user_type
                                }, null, 8, ["name", "image", "time", "text", "user_type"]))
                              : (_openBlock(), _createBlock(_component_MessageOut, {
                                  key: 1,
                                  name: item.user.full_name,
                                  image: item.user.avatar,
                                  time: item.created_at.jalali,
                                  text: item.message,
                                  user_type: item.user_type
                                }, null, 8, ["name", "image", "time", "text", "user_type"]))
                          ], 64))
                        }), 128))
                      ], 512)
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _withDirectives(_createElementVNode("textarea", {
                        type: "textarea",
                        class: "form-control form-control-lg mw-260px",
                        rows: "2",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newMessageText) = $event)),
                        placeholder: _ctx.translate('Enter your message')
                      }, null, 8, _hoisted_40), [
                        [_vModelText, _ctx.newMessageText]
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          (_ctx.route.path === '/management/tickets')
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                disabled: 
                          !_ctx.permission?.includes('ticket_close') &&
                          _ctx.userType?.includes('admin')
                        ,
                                type: "submit",
                                ref: "submitButton2",
                                class: "btn btn-light-danger mt-2",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeTicket(_ctx.list.ticket_number)))
                              }, [
                                _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.translate("close ticket")), 1),
                                _createElementVNode("span", _hoisted_45, [
                                  _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                                  _hoisted_46
                                ])
                              ], 8, _hoisted_43))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("button", {
                          disabled: 
                        !_ctx.permission?.includes('ticket_reply') &&
                        _ctx.userType?.includes('admin')
                      ,
                          type: "submit",
                          id: "kt_account_profile_details_submit",
                          ref: "submitButton1",
                          class: "btn btn-primary mt-2",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewMessage && _ctx.addNewMessage(...args)))
                        }, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.translate("send")), 1),
                          _createElementVNode("span", _hoisted_49, [
                            _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                            _hoisted_50
                          ])
                        ], 8, _hoisted_47)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_7)), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ])
  ], 512))
}